import detect_touch_device from 'lib/detect-touch-device';

/**
 * Only handle resize if the width has changed, or the height has changed by at least 100px, or the height has
 * increased, but once it has increased, if it then decreases, no resize will occur until it decreased by at least
 * 100px, and if it increased again after decreasing (without hitting that 100px threshold), then no resize will occur
 * until it is increased to be larger than the initial height increase.
 *
 * This fixes the issue with jittery parallax/animations where scrolling up and down in mobile browsers shows and hides
 * the browser header bar, which triggers a resize, causing a momentary stutter as a bunch of repaints are triggered
 * when fetching dimensions of animation elements etc.
 *
 * @param callback
 * @param allowHeightIncrease - this will allow the height to grow, but it won't trigger the call back on a height
 * decrease again until the height decreases below the original height.
 * @return {Function}
 */
export function mobile_friendly_resize_callback(callback, allowHeightIncrease = false) {
    const touch = detect_touch_device();
    let width;
    let height;

    function constructor() {
        update_dimensions();
    }

    function should_handle_resize() {
        if (touch.is_touch_device()) {
            return window.innerWidth !== width
                || Math.max(window.innerHeight, height) - Math.min(window.innerHeight, height) > 100
                || (allowHeightIncrease && window.innerHeight > height);
        }

        return true;
    }

    function update_dimensions() {
        width = window.innerWidth;
        height = window.innerHeight;
    }

    function handler() {
        if (should_handle_resize()) {
            update_dimensions();

            callback();
        }
    }

    constructor();

    return handler;
}

export default mobile_friendly_resize_callback;